import { handleActions } from 'redux-actions';
import { offerHotelsAction } from './actions';
export const offerHotelsReducer = handleActions({
    [offerHotelsAction.toString()]: (state, { payload }) => payload
}, false);
